import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-f00e85dc"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "product-container"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h1", {
  class: "dis-space-4 me-max-title"
}, "数字能源", -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "info dis-space-2 me-main-title"
}, "构建能源互联系统新架构，突破用能与供应的传统界限", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "station-title me-main-title"
}, "海量站点区域覆盖，优选合作方为货运保驾护航", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "station-des me-content-vl me-top-lt"
}, "基于货运车辆路线精准营销，提供多元化、规范化的车后市场服务,包括加油加气、 ETC集采、保险产品及车辆维修等。", -1));
const _hoisted_6 = {
  class: "station-adv me-padding-H1 me-top-max"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  class: "station-adv-title me-sub-title me-top"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "station-adv-line"
}, null, -1));
const _hoisted_10 = {
  class: "station-adv-content me-content"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "target-title"
}, "新能源市场业务布局，助力“双碳”目标实现", -1));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "target-des me-sub-title me-top-lt"
}, [/*#__PURE__*/_createTextVNode("通过纯电动重卡与换电式补能技术路线的推广应用，可有效摆脱公路运输燃油依赖、"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 缓解续航里程焦虑问题，帮助节能减排，为自动驾驶与无人作业在典型业务场景下应用创造条件。")], -1));
const _hoisted_13 = {
  class: "target-adv me-padding-H1 me-top-max"
};
const _hoisted_14 = {
  class: "target-adv-title me-sub-title"
};
const _hoisted_15 = {
  class: "target-adv-content me-top-lt"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_button = _resolveComponent("a-button");
  const _component_ConsultModal = _resolveComponent("ConsultModal");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: "banner-box",
    style: _normalizeStyle({
      height: _ctx.bannerHeight
    })
  }, [_createElementVNode("div", {
    class: "banner-info",
    style: _normalizeStyle({
      padding: _ctx.boxPadding
    })
  }, [_hoisted_2, _hoisted_3, _createVNode(_component_a_button, {
    class: "service me-content-lt",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.openConsultModdal())
  }, {
    default: _withCtx(() => [_createTextVNode("立即咨询")]),
    _: 1
  })], 4)], 4), _createElementVNode("div", {
    class: _normalizeClass(["station", {
      'station-entry': _ctx.stationState.showTime
    }]),
    id: "station"
  }, [_hoisted_4, _hoisted_5, _createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stationList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "station-adv-item",
      key: index
    }, [_createElementVNode("img", {
      src: item.img,
      alt: ""
    }, null, 8, _hoisted_7), _createElementVNode("div", _hoisted_8, _toDisplayString(item.title), 1), _hoisted_9, _createElementVNode("div", _hoisted_10, _toDisplayString(item.content), 1)]);
  }), 128))])], 2), _createElementVNode("div", {
    class: _normalizeClass(["target", {
      'target-entry': _ctx.targetState.showTime
    }]),
    id: "target"
  }, [_hoisted_11, _hoisted_12, _createElementVNode("div", _hoisted_13, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.targetList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "target-adv-item",
      key: index,
      style: _normalizeStyle({
        background: `url(${item.img})`
      })
    }, [_createElementVNode("div", _hoisted_14, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_15, _toDisplayString(item.content), 1)], 4);
  }), 128))])], 2), _createVNode(_component_ConsultModal, {
    ref: "consultModalRef"
  }, null, 512)]);
}